import './EnhancedEventViewDetails.scss';
import EnhancedEventViewSpecialEvent from '../EnhancedEventViewSpecialEvent/EnhancedEventViewSpecialEvent';
import EnhancedEventViewRemarks from '../EnhancedEventViewRemarks/EnhancedEventViewRemarks';
import EnhancedEventViewSingleEvent from '../EnhancedEventViewSingleEvent/EnhancedEventViewSingleEvent';
import { eventActivityType } from '../../../constants/myBlockMonth';


const EnhancedEventViewDetails = ({ pairingEvent, eventType, actualView }) => {

  const getSingleEvents = () => {
    return (
      pairingEvent.pairingDetails && pairingEvent.pairingDetails.events && 
      pairingEvent.pairingDetails.events.map((event, eventIndex, eventArray) => (
        <div className="c-ev-details" key={eventIndex}>
          <EnhancedEventViewSingleEvent
            actualView={actualView}  
            eventArray={eventArray} 
            eventIndex={eventIndex}  
            pairingEvent={event}
          />          
        </div>
      )));
  }

  return (
    eventType === eventActivityType.PAIRING ?
      <>
        {getSingleEvents()}
        <EnhancedEventViewRemarks pairingEvent={pairingEvent} />
      </>
      : <EnhancedEventViewSpecialEvent eventType={eventType} pairingEvent={pairingEvent} />
  );
}

export default EnhancedEventViewDetails;
